import { AppContext } from "@/App.context";
import config from "@/config";
import { API_NO_DATA_FOUND_ERROR } from "@/lib/errors/error-constants";
import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";

export const getStatisticsReporting = (token) => {
  return async ({ service, id }) => {
    const owners = await fetch(
      `${config.reportApiHost}/v1/${service}/reporting/delete`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ report_ids: [id] }),
      }
    );
    if (!owners.ok) {
      throw new Error((await owners.json()).message);
    }
    const res = await owners.json();
    return res;
  };
};

/**
 * @param {GetStatisticsCostAnomalyReq} req
 * @param {any[]=} deps
 */
export const useReportDelete = (req, deps = [], enabled = true) => {
  const appContext = useContext(AppContext);
  const query = useQuery({
    queryKey: ["getStatisticsReporting", req, ...deps],
    queryFn: () => getStatisticsReporting(appContext.idToken)(req),
    retry: false,
    enabled,
  });
  return query;
};
